"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Dialog = exports.Dialog = (0, _mui.styled)(_components.Dialog, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['zIndex', 'hasFooter'])
})(({
  theme,
  hasFooter,
  zIndex
}) => ({
  margin: 'auto',
  maxWidth: '100%',
  zIndex,
  [`.${_mui.paperClasses.root}`]: {
    width: '100%'
  },
  [`.${_components.dialogClasses.header}`]: {
    padding: theme.spacing(3, 6, 0, 6)
  },
  [`& .${_components.dialogClasses.content}`]: {
    padding: hasFooter ? 0 : theme.spacing(3, 1, 6, 1),
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  [theme.breakpoints.up('sm')]: {
    [`.${_mui.paperClasses.root}`]: {
      width: '100%',
      maxWidth: 'min(95vw, 600px)'
    }
  }
}));
//# sourceMappingURL=styles.js.map